import { Component } from '@angular/core';
import { Location } from '@angular/common';
// services
import { TranslateService } from '@ngx-translate/core';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'dgx-profile-settings-login',
  templateUrl: './profile-settings-login.component.html',
})
export class ProfileSettingsLogin {
  public readonly CLASS_NAME = 'ProfileSettingsLogin';

  public i18n = this.translateService.instant([
    'Core_Empty_Image_Alt',
    'UserSettingsSvc_SettingsNotPublic',
    'UserSettingsSvc_TryLoggingIn',
  ]);

  constructor(
    private translateService: TranslateService,
    private location: Location,
    private webEnvironmentService: WebEnvironmentService,
    private route: ActivatedRoute
  ) {}

  public ngOnInit() {
    // Set the URL to the setting page that was requested, without navigating so that the returnUrl is picked up as ../settings/* and not
    // ../settings-login
    this.route.queryParams.subscribe((params) => {
      this.location.replaceState(params.returnUrl);
    });
  }

  public get emptyImageUrl(): string {
    return this.webEnvironmentService.getBlobUrl(
      '/content/img/emptystate/profile-settings.svg',
      true
    );
  }
}
